import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'
import { ViewableBy } from '../utilities/viewable-check'

export const HeadingBlockFragment: BlockFragment = {
  name: 'heading',
  fragment: gql`
    fragment heading on Heading {
      id
      blockName
      blockType
      heading
      level
      headingAlignment: alignment
      headingMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on Heading {
      id
      blockName
      level
      headingAlignment: alignment
      blockType
      heading
      headingMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const HeadingBlockType = 'heading'

export interface HeadingBlock extends BaseBlock {
  blockType: typeof HeadingBlockType
  heading: string
  level: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  headingAlignment: 'left' | 'center' | 'right'
  headingMeta?: {
    viewableBy: [ViewableBy]
  }
}
